/**
 *
 * OptionalRouteBadge
 *
 */

import React, { memo } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { COLORS } from '../../../../theme';
import Badge from '..';

const StyledBadge = styled(Badge)`
  &.MuiChip-root {
    color: ${COLORS.white};
    background: ${COLORS.kinetikBlue};
    border-color: ${COLORS.kinetikBlue};
  }
`;

function OptionalRouteBadge({ label, ...props }) {
  return <StyledBadge label={label} {...props} />;
}

OptionalRouteBadge.propTypes = {
  label: PropTypes.string.isRequired,
};

export default memo(OptionalRouteBadge);
